export default function Eyebrow({ children, num, className = '' }) {
  return (
    <div className={`flex items-center gap-3 eyebrow ${className}`}>
      {num && <span className="font-mono">{num}</span>}
      <span className="h-px w-8 bg-current opacity-20" />
      <span>{children}</span>
    </div>
  )
}
